import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const dashboardTeamComparisonSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.TEAM_KPI}`,
        popover: {
            title: "Team Statistics",
            description:
                "A side-by-side snapshot of both teams covering key stats — goals, passes, shots, accuracy, Corsi, Fenwick, " +
                "and overall KPI totals and averages. The leading value in each row is highlighted in gold.",
            side: "bottom",
            align: "center",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_PLAYERS}`,
        popover: {
            title: "Player KPI Ranking",
            description:
                "Players from both rosters ranked side-by-side by their KPI score. " +
                "Use the toggle at the top of the table to switch between skaters and goalkeepers. " +
                "Coloured badges indicate each player's performance tier.",
            side: "top",
            align: "center",
        },
    },
];
